import { Link } from 'react-router-dom';
import { notFoundContent } from '../content/stubs';
import { pageSeo } from '../content/seo';
import { Seo } from '../components/seo/Seo';
import { Section } from '../components/layout/Section';

/**
 * Catch-all route.
 *
 * The server serves index.html for any unmatched GET, so this is what an
 * out-of-date link renders. Noindex, and it offers the two audience paths
 * rather than dead-ending.
 */
export function NotFoundPage() {
  return (
    <>
      <Seo seo={pageSeo.notFound} />
      <Section>
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-signal">
          {notFoundContent.eyebrow}
        </p>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight text-ink sm:text-4xl">
          {notFoundContent.headline}
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-ink/85">
          {notFoundContent.body}
        </p>
        <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-3">
          {notFoundContent.links.map((link) => (
            <li key={link.to}>
              <Link to={link.to} className="text-ink underline underline-offset-4">
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </Section>
    </>
  );
}
